import { CheckCircleOutlined } from '@ant-design/icons';
import { api, Order } from '@restaurant/api';
import { Button, Input } from 'antd';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartActionContext } from '~/App/Layout/providers/CartProvider';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import { DrawerContext } from '~/providers/DrawerProvider';
import message from '~/utils/message';

const CloseOrderPanel = ({
  onSubmit,
}: {
  onSubmit: (notes?: string) => void;
}) => {
  const [notes, setNotes] = useState<string>();

  return (
    <div>
      <div className="mb-6">
        <p className="mb-4">Notes</p>
        <Input
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          size="large"
        />
      </div>
      <Button type="primary" size="large" block onClick={() => onSubmit(notes)}>
        Selesai
      </Button>
    </div>
  );
};

const useCloseButton = ({ order }: { order: Order }) => {
  const { order: currentOrder, newOrder } = useContext(OrderContext);
  const { openDrawer } = useContext(DrawerContext);
  const { resetCart } = useContext(CartActionContext);
  const navigate = useNavigate();

  const onClick = async () => {
    const outstandingPayment =
      order.totalPrice - (order.payment?.totalAmount ?? 0);
    if (outstandingPayment > 0) {
      message.error('Tagihan belum lunas');
      return;
    }

    openDrawer(
      ({ closeDrawer }) => {
        const onSubmit = async (notes?: string) => {
          try {
            await api.closeOrder({ orderId: order.orderId, notes });
            message.success('Order indent selesai!');

            closeDrawer();
            if (!currentOrder.isNew && currentOrder.orderId === order.orderId) {
              newOrder();
              resetCart();
            }
            navigate('/');
          } catch (error: any) {
            message.error('Gagal: ' + error.message);
          }
        };
        return (
          <div>
            <CloseOrderPanel onSubmit={onSubmit} />
          </div>
        );
      },
      {
        height: '30%',
        placement: 'bottom',
      }
    );
  };

  return {
    key: 'close',
    text: 'Selesai',
    icon: <CheckCircleOutlined />,
    onClick,
  };
};

export default useCloseButton;
